import { PaginationRequestParam } from "../api";
import { AbsencetypeDto, EmployeeAvatarDto } from "../organization/company";
import { ApprovalStatus } from "./approval-statuses";
import { BudgetDto } from "./budget";
import { DocumentView } from "./documents";

export interface AbsenceDocumentDto {
  uuid: string;
  fileName: string;
  imgUrl: string;
}

export enum AbsenceApprovalStatus {
  NOT_REQUIRED = "NOT_REQUIRED",
  REQUESTED = "REQUESTED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum AbsenceDocumentStatus {
  NOT_REQUIRED = "NOT_REQUIRED",
  PROVIDED = "PROVIDED",
  MISSING = "MISSING",
  ELECTRONIC_CERTIFICATE = "ELECTRONIC_CERTIFICATE",
  ELECTRONIC_CERTIFICATE_REQUESTED = "ELECTRONIC_CERTIFICATE_REQUESTED",
  ELECTRONIC_CERTIFICATE_FOLLOWUP_REQUESTED = "ELECTRONIC_CERTIFICATE_FOLLOWUP_REQUESTED",
  ELECTRONIC_CERTIFICATE_RECEIVED = "ELECTRONIC_CERTIFICATE_RECEIVED",
}

export enum DocumentStatus {
  NOT_REQUIRED = "NOT_REQUIRED",
  PROVIDED = "PROVIDED",
  MISSING = "MISSING",
  ELECTRONIC_CERTIFICATE = "ELECTRONIC_CERTIFICATE",
  ELECTRONIC_CERTIFICATE_REQUESTED = "ELECTRONIC_CERTIFICATE_REQUESTED",
  ELECTRONIC_CERTIFICATE_FOLLOWUP_REQUESTED = "ELECTRONIC_CERTIFICATE_FOLLOWUP_REQUESTED",
  ELECTRONIC_CERTIFICATE_RECEIVED = "ELECTRONIC_CERTIFICATE_RECEIVED",
}

export enum AbsenceAllowedAction {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  EDIT = "EDIT",
  DELETE = "DELETE",
  UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT",
  REQUEST = "REQUEST",
}

export enum BudgetStatus {
  UPCOMING = "UPCOMING",
  EXPIRED_CARRY_OVER = "EXPIRED_CARRY_OVER",
  EXPIRED = "EXPIRED",
  VALID = "VALID",
}

export interface AdjustAbsenceRequestStatus {
  absenceRequestId: string;
  status: ApprovalStatus;
}

export interface AdjustAbsenceRequestEndDate {
  absenceRequestId: string;
  endDate: string | null;
  endWithHalf?: boolean;
}

export interface AbsenceRequestCreate {
  startDate: string;
  endDate: string | null;
  startWithHalf: boolean;
  endWithHalf: boolean;
  endDateExists: boolean;
  comment: string | null;
  absenceTypeId: string;
  appliedOvertimeScheduleId: string | null;
}

export interface AbsenceRequestView {
  uuid: string;
  employeeDto: EmployeeAvatarDto;
  startDate: string;
  endDate: string;
  startWithHalf: boolean;
  endWithHalf: boolean;
  duration: number;
  budgetId: string;
  requestDate: string;
  allowedActions: AbsenceAllowedAction[];
  comment: string | null;
  approvalStatus: ApprovalStatus;
  documentStatus: DocumentStatus;
  absencetype: AbsencetypeDto;
  budget: BudgetDto;
  absenceDocuments: DocumentView[];
}

export interface AbsenceRequestParam extends PaginationRequestParam {
  startDate?: string;
  endDate?: string;
  employeeId?: string;
  approvalStatuses?: ApprovalStatus;
  documentStatuses?: DocumentStatus;
  absenceTypeIds?: string;
  departmentId?: string;
  companyId?: string;
  budgetIds?: string;
  locationId?: string;
  scheduleId?: string;
  workingType?: string;
}

export interface AbsenceRequestPayload {
  startDate: string;
  endDate: string;
  workContractIds: string[];
}

export interface AbsenceCheck {
  days: number;
  absenceType: AbsencetypeDto;
  budget: BudgetDto;
  submittable: boolean;
  message: string;
  requestDays: RequestDayInterface[];
  carryOverRemaining: string;
}

export interface RequestDayInterface {
  absenceTypeName: string;
  overWriteable: boolean;
  date: string;
}
